import { apiClient } from '../client';
import { AuditLogEntry } from '../../types/admin';

export const auditApi = {
  forEntity: (entityType: string, entityId: number) =>
    apiClient.get<{ data: AuditLogEntry[] }>(`/api/admin/audit?entityType=${encodeURIComponent(entityType)}&entityId=${entityId}`),
};
